import React from 'react';
import { AccountCintainer, EditInfoRow } from './styledComponents';
import styles from './styles';
import LinkAccount from './components/LinkAccount/';
import PlayerInfo from './components/PlayerInfo';
import EditInfoSection from './components/EditInfoSection';
import PromotionSection from './components/PromotionSection';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ImageBW from '../../../components/ImageBoundsWrapper';

const AccountSettings = props => {
  const {
    email,
    emailOptIn,
    isGuest,
    verifiedAccount,
    lastLoginInfo,
    toggleEmailOptIn,
    onChangeComponentHandler,
    screensEnum,
    isLinkGuestAccountEnabled,
  } = props;
  const isGuestUser = isGuest || lastLoginInfo.loginMethod === 'Guest';
  const isEditInfoEnable =
    !isGuestUser &&
    (ENVIRONMENT_VARIABLES.ACCOUNT_EMAIL === 'true' || ENVIRONMENT_VARIABLES.ACCOUNT_CHANGE_PASSWORD === 'true');

  return (
    <AccountCintainer>
      <PlayerInfo {...props} isGuestUser={isGuestUser} />
      {isEditInfoEnable && (
        <>
          <EditInfoRow>
            {ENVIRONMENT_VARIABLES.ACCOUNT_EMAIL === 'true' && (
              <EditInfoSection
                title={getText(TEXT_KEY.EMAIL)}
                handle={() => onChangeComponentHandler(screensEnum.updateEmail)}
                value={email}
                verifiedAccount={verifiedAccount}
              />
            )}
            {ENVIRONMENT_VARIABLES.ACCOUNT_CHANGE_PASSWORD === 'true' && (
              <EditInfoSection
                title={getText(TEXT_KEY.CHANGE_PASSWORD)}
                handle={() => onChangeComponentHandler(screensEnum.changePassword)}
                value={getText(TEXT_KEY.PASSWORD_HINT)}
                verifiedAccount={verifiedAccount}
                isPassword={true}
              />
            )}
          </EditInfoRow>
          <div className="bottom-divider">
            <ImageBW
              style={styles.divider}
              source={require(asset`./images/Settings/Settings_Divider@3x.png`)}
              ibw={require(asset`./images/Settings/Settings_Divider.ibw`)}
              widthScale={0.5}
            />
          </div>
        </>
      )}
      {isGuestUser && isLinkGuestAccountEnabled && <LinkAccount />}
      <PromotionSection handle={() => toggleEmailOptIn()} value={emailOptIn} />
    </AccountCintainer>
  );
};

export default AccountSettings;

